module.exports = __webpack_public_path__ + "static/media/submit_benchmark_run.e286da0d.png";